import { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBlock } from '../components/TrustBlock';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { DestinationsSection } from '../components/DestinationsSection';
import { VisaServicesSection } from '../components/VisaServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ProcessTimeline } from '../components/ProcessTimeline';
import { LocationSection } from '../components/LocationSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { BookDemoModal } from '../components/BookDemoModal';
import { contactInfo } from '../data/mock';
import { MessageCircle } from 'lucide-react';

export default function HomePage() {
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0A1628]">
      <Header onBookDemo={() => setDemoOpen(true)} />
      <HeroSection onBookDemo={() => setDemoOpen(true)} />
      <TrustBlock />
      <AboutSection />
      <ServicesSection />
      <DestinationsSection />
      <VisaServicesSection />
      <TestimonialsSection />
      <ProcessTimeline />
      <LocationSection onBookDemo={() => setDemoOpen(true)} />
      <CTASection onBookDemo={() => setDemoOpen(true)} />
      <Footer />

      {/* Book Demo Modal */}
      <BookDemoModal open={demoOpen} onOpenChange={setDemoOpen} />

      {/* Floating WhatsApp Button */}
      <a
        href={`https://wa.me/${contactInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 hover:scale-110 transition-[box-shadow,transform] duration-300"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
    </div>
  );
}
